<ng-container *ngIf="allCompleted && customCardCategory !== cardCategory.saved">
  <div class="card-wrap">
    <div class="card empty-state">
      <p class="exclamation">Great Work!</p>
      <ng-container *ngIf="customCardCategory === cardCategory.actions">
        <p class="text">
          You've completed all of your actions for today. Go to
          <a routerLink="/cards/saved">Saved</a>
          or
          <a routerLink="/discover" [queryParams]="{ resetSearch: true }">Discover</a>
          to find new ones to try.
        </p>
      </ng-container>

      <ng-container *ngIf="customCardCategory === cardCategory.quests">
        <p class="text">
          You've completed all of your quests. Go to
          <a routerLink="/discover" [queryParams]="{ searchTerm: 'Quest' }">Discover</a>
          to find new ones to start.
        </p>
      </ng-container>
    </div>
  </div>
</ng-container>

<!--NOTE: Using screen here because of a difference in card appearance on the notifications page. We should try not to rely on screen -->
<ng-container *ngIf="noReminders && screen === cardScreen.reminders && cardDisplayType === cardDisplayTypes.reminder">
  <div class="card-wrap">
    <div class="card empty-state card-action-reminder">
      <p class="text">
        Set reminders on your cards in
        <a routerLink="/cards/actions">My Actions</a>
        to get started!
      </p>
    </div>
  </div>
</ng-container>

<!-- Reminder cards -->
<a
  class="card-wrap card-reminder"
  [href]="cardUrl"
  (keydown)="handleKeyboardEvent($event)"
  (click)="detailView($event)"
  *ngIf="card && !card.hideFromUI && shouldShowCard && cardDisplayType === cardDisplayTypes.reminder">
  <div class="card-action-reminder">
    <div class="action-reminder-details">
      <h2 class="action-reminder-title">{{ card.title }}</h2>
      <p class="action-reminder-schedule">{{ reminderScheduleText }}</p>
    </div>
    <svg-icon class="icon-chevron" src="assets/icons/chevron-right-nocircle.svg"></svg-icon>
  </div>
</a>

<!-- Checklist cards -->
<a
  class="card-wrap card-checklist"
  [href]="cardUrl"
  (keydown)="handleKeyboardEvent($event)"
  (click)="detailView($event)"
  *ngIf="card && cardDisplayType === cardDisplayTypes.checklist">
  <div
    class="card-take-action"
    [ngClass]="{
      'completed-action': card.userState.isCompleted,
      'checklist-animation': card.userState.isCompleted && shouldShowAnimation
    }">
    <kp-card-actions
      class="card-take-action-icon"
      [card]="card"
      [screen]="screen"
      [requestType]="requestType"></kp-card-actions>
    <div class="card-take-action-details">
      <h2 class="card-take-action-title">{{ card.title }}</h2>
      <!-- TODO: card-take-action-reminder = not just reminderSchedule, should be Time + Reason -->
      <p class="card-take-action-reminder" *ngIf="!card.userState?.isCompleted">
        {{ reminderScheduleText }}
      </p>
      <p class="card-take-action-reminder" *ngIf="card.userState?.isCompleted">Completed!</p>
    </div>
    <svg-icon class="icon-chevron" src="assets/icons/chevron-right-nocircle.svg"></svg-icon>
  </div>
</a>

<!-- Default card -->
<ng-container *ngIf="card && ![cardDisplayTypes.reminder, cardDisplayTypes.checklist].includes(cardDisplayType)">
  <a
    class="card-wrap"
    [href]="cardUrl"
    (keydown)="handleKeyboardEvent($event)"
    (click)="detailView($event)"
    *ngIf="card && !card.hideFromUI && shouldShowCard">
    <div
      [ngClass]="{
        completed: card.userState?.isCompleted
      }"
      class="card"
      *ngIf="card">
      <div
        *ngIf="card.contentType === cardContentType.card"
        class="card-image hidden-print"
        [style.background-image]="card.cardImage?.url != null ? 'url(' + card.cardImage?.url + '?w=744)' : false">
        <svg-icon
          *ngIf="card?.userState?.notifications?.length > 0"
          class="reminder-icon"
          src="/assets/icons/reminder.svg"></svg-icon>
      </div>
      <div
        *ngIf="card.contentType === cardContentType.localResource"
        class="card-image local-resource-image hidden-print"></div>
      <ng-container *ngIf="card.contentType === cardContentType.localResource">
        <div class="local-resource-header">
          <svg-icon class="local-resource-icon" src="/assets/icons/location.svg"></svg-icon>
          <span class="topic-local-resource">Local Resource</span>
        </div>
      </ng-container>
      <div class="card-info">
        <h2 class="title">
          {{ card.title }}
        </h2>
        <h2 class="totd-header" *ngIf="requestType === cardRequestType.TOTD">
          <span>Tip of the Day</span>
          <kp-like-icon
            class="icon-action"
            [preference]="card.userState?.preference"
            [likeCount]="card?.userState?.likeCount"
            [color]="(themeService.theme$ | async)?.onBackground"
            size="14"
            (likeChanged)="likeChanged()"></kp-like-icon>
        </h2>
        <ng-container *ngIf="requestType !== cardRequestType.TOTD">
          <div class="bottom-container">
            <div class="topic" *ngIf="card.contentType === cardContentType.localResource">
              by {{ card.providerName }}
            </div>
            <div class="tertiary-card-info completion-text" *ngIf="card.contentType === cardContentType.card">
              {{ tertiaryCardInfo }}
            </div>
          </div>
          <progress
            class="progress-bar"
            *ngIf="
              !card.userState?.isCompleted && card.userState.availableItemCount && card.userState.completedItemCount > 0
            "
            [max]="card.userState.availableItemCount"
            [value]="card.userState.completedItemCount"></progress>
          <kp-card-actions [card]="card" [screen]="screen" [requestType]="requestType"></kp-card-actions>
        </ng-container>
      </div>
    </div>
  </a>
</ng-container>

<kp-animation-card
  *ngIf="shouldShowAnimation && screen !== cardScreen.reminders"
  [card]="card"
  [requestType]="requestType"
  [displayType]="cardDisplayType"></kp-animation-card>
